import { SelectHTMLAttributes, forwardRef } from 'react';
import { FaqCategory } from 'src/services/keystone-types';

type Props = SelectHTMLAttributes<HTMLSelectElement> & {
    categories: FaqCategory[];
};

const FaqCategories = forwardRef<HTMLSelectElement, Props>((props, ref) => {
    const { categories, ...rest } = props;
    return (
        <select {...rest} ref={ref} className="mb-4 md:mb-0 md:w-1/3">
            <option value="">Selectează o categorie</option>
            {categories?.map((c) => (
                <option key={c.id} value={c.slug}>
                    {c.name}
                </option>
            ))}
        </select>
    );
});

FaqCategories.displayName = 'FaqCategories';

export default FaqCategories;
